import { render, staticRenderFns } from "./DeviceInfoAppendix.vue?vue&type=template&id=af12b008&scoped=true"
import script from "./DeviceInfoAppendix.vue?vue&type=script&lang=js"
export * from "./DeviceInfoAppendix.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af12b008",
  null
  
)

export default component.exports